import { api } from './api';

/**
 * My Tasks aggregate service (plan 88).
 * Backs the /tasks page (getTasks / getGroup) and the sidebar badge (getSummary).
 */
class TasksService {
  _headers(authorizationToken, tenant) {
    const headers = {};
    if (authorizationToken) headers['Authorization'] = 'Bearer ' + authorizationToken;
    if (tenant) headers['tenant'] = tenant;
    return headers;
  }

  /**
   * Full My Tasks payload: five groups with counts + top contacts.
   * @param {{ listIds?: string, perGroupLimit?: number }} opts
   */
  async getTasks(authorizationToken, tenant, { listIds, perGroupLimit } = {}) {
    const params = new URLSearchParams();
    if (listIds) params.set('list_ids', listIds);
    if (perGroupLimit) params.set('per_group_limit', perGroupLimit);
    const qs = params.toString();
    const response = await api.get(`/v1/funnel/tasks${qs ? '?' + qs : ''}`, {
      headers: this._headers(authorizationToken, tenant),
    });
    return response.data;
  }

  /**
   * A single group, paginated — powers the "Show all" expander.
   * @param {{ listIds?: string, limit?: number, offset?: number }} opts
   */
  async getGroup(authorizationToken, tenant, group, { listIds, limit, offset } = {}) {
    const params = new URLSearchParams();
    params.set('group', group);
    if (listIds) params.set('list_ids', listIds);
    if (limit != null) params.set('limit', limit);
    if (offset != null) params.set('offset', offset);
    const response = await api.get(`/v1/funnel/tasks?${params.toString()}`, {
      headers: this._headers(authorizationToken, tenant),
    });
    return response.data;
  }

  /** Counts-only summary for the sidebar badge. */
  async getSummary(authorizationToken, tenant) {
    const response = await api.get('/v1/funnel/tasks/summary', {
      headers: this._headers(authorizationToken, tenant),
    });
    return response.data;
  }
}

export const tasksService = new TasksService();
export default tasksService;
